import _u from './util';
import _v from './vars';
import _f from './func';
import _feed from './templates/feed_t';
import _cme from './templates/cmeglider_t';
import _ from 'lodash';

let indexValuesForFeeds = 0;
let cmeGliderAppended = false;

function feedApiUrl() {
	let queryParams = 'page=' + _v.pageNumber + '&limit=' + _v.pageSize ;
	if (typeof userHpId != 'undefined' && userHpId != '' && !isNaN(Number(userHpId))) {
		queryParams = queryParams+ '&homePageId=' + userHpId;
	}
	if (_v.topContId || _v.topArticleId) {
		queryParams = (_v.topContId ? 'aspen_feed_nid=' + _v.topContId: 'article_id='+_v.topArticleId)+'&'+queryParams;
	}
	return _v.contentFeedURL+queryParams+ ((typeof window.hideCmeGlider != 'undefined' && window.hideCmeGlider)?'':'&exclude=cme') + '&pvid=' + s_pageview_id;
}

function removeFeedLoader() {
    if (document.querySelectorAll('.new-loading-screen, #left-rail-loading-section .pers-feed-item').length > 0) {
        document.querySelectorAll('.new-loading-screen, #left-rail-loading-section .pers-feed-item').forEach(function (a) {
            _u.removeElem(a);
        });
    }
    if (document.getElementById('left-rail-loading-section') != null && document.getElementById('left-rail-loading-section').firstElementChild == null) {
        _u.removeElem(document.getElementById('left-rail-loading-section'));
    }
}

function getFeed() {
	return new Promise(function(resolve, reject) {		
		if (_v.pageNumber !== 1) {
			GenPVID();
		}		
		_u.apiGet(feedApiUrl(), true).then(feed => {
			if (feed) {
				
				// Stops infinite-scroll on last page
				if (feed.metadata.page_count && feed.metadata.page) {
					if (feed.metadata.page_count === feed.metadata.page) {
						_v.noMoreRecEngineFeedContent = true;
						document.dispatchEvent(new CustomEvent('feedDone'));
					}
				}
				
				// Remove loading graphics
				removeFeedLoader();
				
				// If Results exist
				if (feed.data.length > 0) {
					
					// Store first page of results for feed-refresh comparison
					if (_v.pageNumber < 2) {
						_v.firstPageFeedData = feed.data;
					}
					
					// Send Omniture Pageview after first page, upon infinite scroll
					if (_v.pageNumber !== 1) {
						wmdTrack('fy-pg_' + _v.pageNumber);
						wmdPageview('', _v.pageNumber);
					}

					// Loop through results
					feed.data.forEach(function(feedData, index) {
						
						// Turn all null value into empty string for output in LoDash template
						Object.keys(_.pickBy(feedData, _.isNull)).forEach(function(key) {
							feedData[key] = '';
						});

						// Increment counter for tracking calls
						indexValuesForFeeds++;
						
						// Ensure URI is environment-specific
						if (typeof feedData.uri == 'string') {
							feedData.uri = feedData.uri.replace(/((https?:)?\/\/)([^\.]+)(.+)?\.(medscape\.)([^\/]+)/, '$1$3.' + _u.getDomain() + '$5$6');
						}
						if(_v.isFYE != null){
							feedData.uri = feedData.uri + '?src=FYE';
						}
						// Add Akamai resizer
						if (typeof feedData.imageUrl == 'string' && feedData.imageUrl.trim() != "") {
							feedData.imageUrl = feedData.imageUrl.toString() + '?interpolation=lanczos-none&resize=120:*';
						}
						
						// Dedupe Top Article from Feed
						if (_v.topArticleId != null && String(feedData.contentId) == String(_v.topArticleId)) {
							return;
						} else if (_v.topContId != null && String(feedData.aspenNid) == String(_v.topContId)) {
							return;
						}

						// Parse date
						if (feedData.contentType != 'Blog') {
							feedData.publicationDate = _u.timeParse(feedData.publicationDate);
						} else {
							feedData.publicationDate = '';
						}
						
						// Default tracking value
						feedData.trackingValue = 'fy-cont_' + indexValuesForFeeds;

						// Select LoDash template and adjust data as needed for different content
						
						// Third-party
						if (typeof feedData.sourceOrigin != 'undefined' && feedData.sourceOrigin === 'krzana') {
							// Image credit for third party article
							if (typeof feedData.imageCredit != 'undefined' && feedData.imageCredit != null && feedData.imageCredit.trim() != '') {
								feedData.imageCredit = "Credit: " + feedData.imageCredit;
							}
							feedData.trackingValue = 'fy-thrd_' + indexValuesForFeeds + '|' + feedData.aspenNid;
							try {
								document.querySelector('.feed-container').appendChild(_u.strToDom(_feed.thirdPartyFeedItem(feedData)));
							} catch (e) {
								console.log(e);
							}
						}
						
						// CME
						else if (feedData.uri.indexOf("medscape.org") != -1) {
							let data = ''
							data = _f.getCmeCreditTypeValue(feedData.cmeCreditType);
							feedData.credits = data.credits;

							data.credits != undefined && Number(data.creditvalue) > 0 ?
							feedData.cmeTagName = 'Accredited Education' : feedData.cmeTagName = 'Education';
							feedData.trackingValue = 'fy-contcme_' + indexValuesForFeeds;
							try {
								document.querySelector('.feed-container').appendChild(_u.strToDom(_feed.cmeFeedItem(feedData)));
							} catch (e) {
								console.log(e);
							}
						}
						
						// Beyond The Guidelines
						else if (typeof feedData.contentType == 'string' && feedData.contentType.toLowerCase() === "beyond the guidelines") {
							feedData.superTitle = "BEYOND THE GUIDELINES";
							feedData.publicationName = 'Medscape Decision Point';
							feedData.trackingValue = 'fy-contbtg_' + indexValuesForFeeds;
							try {
								document.querySelector('.feed-container').appendChild(_u.strToDom(_feed.dpFeedItem(feedData)));
							} catch (e) {
								console.log(e);
							}
						}
						
						// Decision Point
						else if (typeof feedData.contentType == 'string' && feedData.contentType.toLowerCase() === "decision point") {
							feedData.superTitle = '';
							feedData.publicationName = 'Medscape Decision Point';
							feedData.trackingValue = 'fy-contbtg_' + indexValuesForFeeds;
							try {
								document.querySelector('.feed-container').appendChild(_u.strToDom(_feed.dpFeedItem(feedData)));
							} catch (e) {
								console.log(e);
							}
						}
						
						// Comp Report Slideshow
						else if (feedData.uri.indexOf('/slideshow/') !== -1 && feedData.title.indexOf('Compensation Report') !== -1) {
							try {
								document.querySelector('.feed-container').appendChild(_u.strToDom(_feed.compReportFeedItem(feedData)));
							} catch (e) {
								console.log(e);
							}
						}
						
						// Slideshow
						else if (feedData.uri.indexOf('/slideshow/') !== -1) {
							feedData.publicationName = 'Slideshows';
							try {
								document.querySelector('.feed-container').appendChild(_u.strToDom(_feed.slideshowFeedItem(feedData)));
							} catch (e) {
								console.log(e);
							}
						}
						
						// Default / News
						else {
							try {
								document.querySelector('.feed-container').appendChild(_u.strToDom(_feed.feedItem(feedData)));
							} catch (e) {
								console.log(e);
							}
						}
						
					}); // End forEach loop through results
					
					_v.processing = false; // allows infinite-scroll to resume
					_v.pageNumber += 1;
					resolve();
					document.dispatchEvent(new CustomEvent('feedLoaded'));

				} else {
					removeFeedLoader();
					resolve();
				}
			} else {
				removeFeedLoader();
				resolve();
			}
		}).catch((error) => {
			removeFeedLoader();
			resolve();
		});
	});
}

export default getFeed;